

























import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class PreviewCollectionField extends Vue {
  @Prop()
  readonly label!: string;

  @Prop()
  readonly icon!: string;

  @Prop()
  readonly collection!: any

  @Prop()
  readonly name!: string;

  get collectionItems(): any[] {
    const itemsObject = this.collection?.items;
    if (Array.isArray(this.collection)) {
      return this.collection;
    }
    if (itemsObject) {
      const collectionKey = Object.keys(itemsObject)[0];
      return this.collection?.items[collectionKey] || [];
    }
    return [];
  }

  get workHeaders() {
    return this.workDataOptions.map((v: any) => ({
      text: v.text,
      value: v.value,
    }));
  }

  get workDataOptions(): Array<{ text: any; value: string; normalizer?: any }> {
    return [
      {
        text: this.$t('work_type'),
        value: 'work_type',
      },
      {
        text: this.$t('units'),
        value: 'units',
      },
      {
        text: this.$t('size'),
        value: 'size',
      },
      {
        text: this.$t('suppliers'),
        value: 'supplier',
      },
      {
        text: this.$t('recommend_quantity'),
        value: 'recommend_quantity',
      },
    ];
  }
}
